module.exports = __webpack_public_path__ + "nunito-sans-latin-600.5a71131c00b436beb97dd2c570768f05.woff";